// 导入Vue
import Vue from 'vue';
// 导入App.vue组件（App是根组件，所有其他的组件都要在App里面使用）
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '/src/assets/css/global.css';
import App from './App.vue';
import router from './router/index.js'
import axios from 'axios'
axios.defaults.baseURL='http://biostatistics.online:5000/'
// axios.defaults.baseURL='http://localhost:5000/'


Vue.use(ElementUI);
Vue.prototype.$http = axios

new Vue({
  // render函数用于渲染App组件
  render: h => h(App),
  router
}).$mount('#app');  //通过$mount方法，指定挂载的容器

// 其实就是将App组件渲染后的内容挂载到了#app容器中